export default __webpack_public_path__ + "static/media/Topaz_partment_11.9512c4d7.jpg";